<template>
  <div class="leak-item bg-white rounded-md border-gray-200 mb-2 relative hover:bg-gray-accent shadow-sm">
    <div class="block text-sm">
      <!-- Mobile & Medium View (stacked) -->
      <div class="p-2">
        <div class="flex items-center mb-1.5">
          <img
            :src="favicon"
            :alt="`${title} favicon`"
            class="w-4 h-4 mr-2 flex-shrink-0"
          >
          <div class="truncate">
            <p class="font-semibold text-gray-800 truncate text-sm" :title="title">{{ title }}</p>
            <p class="text-gray-500 truncate text-xs" :title="url">{{ url }}</p>
          </div>
        </div>
        <div class="text-xs text-gray-600 mb-1">
          <span v-if="foundOn === 'website'">{{ foundOnWebsite }}</span>
          <span v-else class="flex items-center">
            {{ foundThrough }} 
            <img
              src="/build/images/search-engines/google.png"
              alt="Google Images"
              class="w-3 h-3 ml-1 mr-0.5 flex-shrink-0"
            >
            Google Images
          </span>
        </div>
        <div class="text-xs text-gray-500 mb-1.5">{{ date }}</div>
        <div class="flex flex-wrap items-center gap-2">
          <span
            class="text-xs font-semibold px-1.5 py-0.5 rounded-full"
            style="background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);"
          >
            {{ statusText }}
          </span>
          <span class="text-xs text-gray-600">{{ removalType }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  url: {
    type: String,
    required: true
  },
  favicon: {
    type: String,
    required: true
  },
  foundOn: {
    type: String,
    required: true
  },
  foundOnWebsite: {
    type: String,
    required: true
  },
  foundThrough: {
    type: String,
    required: true
  },
  date: {
    type: String,
    required: true
  },
  statusText: {
    type: String,
    required: true
  },
  removalType: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
/* Keep original leak item styling exactly as in app */
.leak-item {
  transition: background-color 0.2s ease;
}
</style>